import styled from 'styled-components';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1px 1fr;
	gap: 20px;
	height: 100%;
`;

const StyledColumnContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding-top: 20px;
`;

const StyledColumnHeadContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledCounter = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 20px;
	height: 20px;
	padding: 0 5px;
	background-color: #1782ff;
	border-radius: 5px;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledRequestsList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const StyledRequestItem = styled.div`
	display: grid;
	grid-template-columns: 63px 1px 1fr auto;
	gap: 20px;
	align-items: center;
	height: 60px;
	min-height: 60px;
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 5px;
	padding: 0 20px;
	cursor: pointer;

	${Divider} {
		height: 20px;
		opacity: 0.1;
	}
`;

const StyledRequestNumber = styled(Text)`
	font-weight: 500;
	font-size: 14px;
	color: #ffffff;

	span {
		opacity: 0.25;
	}
`;

const StyledRequestPlayerName = styled(Text)`
	font-weight: 500;
	font-size: 14px;
	color: #ffffff;

	span {
		font-weight: 400;
		opacity: 0.25;
	}
`;

const StyledRequestPlayerNameChange = styled(Text)`
	font-weight: 500;
	font-size: 14px;
	color: #ffffff;

	span {
		font-weight: 400;
		opacity: 0.5;
	}
`;

const StyledRequestPlayerID = styled(Text)`
	font-size: 14px;
	color: #ffffff;
	opacity: 0.25;
`;

export {
	StyledColumnContainer,
	StyledColumnHeadContainer,
	StyledContainer,
	StyledCounter,
	StyledRequestItem,
	StyledRequestNumber,
	StyledRequestPlayerID,
	StyledRequestPlayerName,
	StyledRequestPlayerNameChange,
	StyledRequestsList,
};
